// extracted by mini-css-extract-plugin
export var autoPromo = "partners-module--autoPromo--ckB5e";
export var backtoschool = "partners-module--backtoschool--ft6hJ";
export var cashBack100 = "partners-module--cashBack100--Ey0dV";
export var genderAction = "partners-module--genderAction--6K1UQ";
export var getHalvaBlackFr = "partners-module--getHalvaBlackFr--EjhRz";
export var invitefriend = "partners-module--invitefriend--SIDZ2";
export var logo = "partners-module--logo--UG7Y3";
export var newYear = "partners-module--newYear--qYwR4";
export var newYearMedia = "partners-module--newYearMedia--rAjNt";
export var p_0 = "partners-module--p_0--Wqrue";
export var section = "partners-module--section---r2K8";
export var slide = "partners-module--slide--QyU-L";
export var subTitlePartners = "partners-module--subTitlePartners--wSEnC";
export var sub_title = "partners-module--sub_title--Qe4bu";
export var swiperOffset = "partners-module--swiperOffset--UaK6M";
export var text = "partners-module--text--yE5nr";
export var title = "partners-module--title--1uHSH";
export var title_container = "partners-module--title_container--sVYzB";
export var vkEducation = "partners-module--vkEducation--ElEhZ";